import { createSelector } from 'reselect';
import type { ApplicationPermissions } from '@atlassian/jira-shared-types/src/tenant-context.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createSubscriber } from '@atlassian/react-sweet-state';
import Store from '../../store.tsx';
import type { Actions, State } from '../../types.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

type SelectorOutput = {
	data: {
		applicationPermissions: ApplicationPermissions;
	};
};

const selector = createSelector(
	(state: State) => state.tenantContext.appPermissions,
	(applicationPermissions) => ({
		data: { applicationPermissions },
	}),
);

export const ApplicationPermissionsSubscriber = createSubscriber<
	State,
	Actions,
	SelectorOutput,
	undefined
>(Store, {
	displayName: 'ApplicationPermissionsSubscriber',
	selector,
});

export const useApplicationPermissions = (): ApplicationPermissions => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.appPermissions;
};
